export default __webpack_public_path__ + "static/media/ministerio-01.45492a1d.svg";